import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CarouselItemStyle, TutoStepContent } from '@shared/models';
import { VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant5',
  imports: [VariableReplacementPipe],
  styleUrl: './variant5.component.scss',
  templateUrl: './variant5.component.html',
})
export class Variant5Component extends BaseComponent {
  itemStyle = input.required<Omit<CarouselItemStyle, 'description'>>();
  stepContent =
    input.required<Omit<TutoStepContent, 'description' | 'indicatorImage'>>();

  public maxSelectedChallenges = this.environment.maxSelectedChallenges;
}
